module.exports = __webpack_public_path__ + "static/9-55606d922514337c7a3242c6cf8c8c33.jpeg";